import { mallApi } from '../request'
import { apiPath } from '../api'

export const userCenter = {
  getKeyContent: () => mallApi.post(apiPath.getKeyContent),
  submitKey: data => mallApi.post(apiPath.submitKey, data)
}
